/* Rivintage — JavaScript del tema (nessuna dipendenza esterna) */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Menu a cassetto ---------- */
  function initDrawer() {
    var drawer = qs('[data-drawer]');
    if (!drawer) return;
    var openers = qsa('[data-drawer-open]');
    var closers = qsa('[data-drawer-close]', drawer);
    var panel = qs('.drawer__panel', drawer);
    var lastFocus = null;

    function focusables() {
      return qsa('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', panel);
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.style.overflow = 'hidden';
      var f = focusables();
      if (f.length) f[0].focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Ricerca nell'header ---------- */
  function initSearchToggle() {
    var modal = qs('[data-search-modal]');
    var toggles = qsa('[data-search-toggle]');
    if (!modal || !toggles.length || modal.dataset.bound) return;
    modal.dataset.bound = '1';
    var header = modal.closest('.site-header');
    function setOpen(open) {
      modal.hidden = !open;
      toggles.forEach(function (t) { if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (header) header.classList.toggle('is-search-open', open);
      if (open) {
        var input = qs('input[type="search"]', modal);
        if (input) setTimeout(function () { input.focus(); }, 30);
      } else if (toggles[0]) {
        toggles[0].focus();
      }
    }
    toggles.forEach(function (t) { t.addEventListener('click', function () { setOpen(modal.hidden); }); });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- Ricerca istantanea ---------- */
  var SEARCH_FIELDS = 'title,vendor,product_type,tag,variants.title';
  function initPredictive(root) {
    qsa('[data-predictive]', root).forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var input = qs('input[type="search"]', box);
      var results = qs('[data-predictive-results]', box);
      var clearBtn = qs('[data-predictive-clear]', box);
      if (!input || !results) return;
      var timer, controller, cache = {};

      function close() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        box.classList.remove('has-results');
      }
      function show(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.getElementById('PredictiveResults');
        results.innerHTML = content ? content.innerHTML : '';
        results.hidden = !results.innerHTML.trim();
        input.setAttribute('aria-expanded', results.hidden ? 'false' : 'true');
        box.classList.toggle('has-results', !results.hidden);
      }
      function search(q) {
        if (cache[q]) { show(cache[q]); return; }
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        box.classList.add('is-loading');
        var url = (routes.predictiveSearch || '/search/suggest') +
          '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=8&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=' + SEARCH_FIELDS;
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) { cache[q] = html; if (input.value.trim() === q) show(html); })
          .catch(function (err) { if (err.name !== 'AbortError') close(); })
          .then(function () { box.classList.remove('is-loading'); });
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = !q;
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () { search(q); }, 160);
      });
      input.addEventListener('focus', function () { if (results.innerHTML.trim() && input.value.trim().length > 1) { results.hidden = false; box.classList.add('has-results'); } });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var first = qs('a', results);
          if (first && !results.hidden) { e.preventDefault(); first.focus(); }
        }
      });
      results.addEventListener('keydown', function (e) {
        var links = qsa('a', results);
        var i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : input).focus(); }
      });
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !results.hidden) { e.stopPropagation(); close(); input.focus(); } });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
      if (clearBtn) clearBtn.addEventListener('click', function () {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      qsa('[data-search-chip]', box).forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          input.value = chip.dataset.searchChip;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          clearTimeout(timer);
          search(input.value.trim());
          input.focus();
        });
      });
      if (input.value.trim() && clearBtn) clearBtn.hidden = false;
    });
  }

  /* ---------- Carosello ---------- */
  function initCarousels() {
    qsa('[data-carousel]').forEach(function (carousel) {
      var track = qs('[data-carousel-track]', carousel);
      var prev = qs('[data-carousel-prev]', carousel);
      var next = qs('[data-carousel-next]', carousel);
      if (!track || carousel.dataset.bound) return;
      carousel.dataset.bound = '1';
      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        carousel.classList.toggle('is-static', max <= 2);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      /* Scorrimento automatico (si ferma con mouse, dito o tastiera) */
      var seconds = parseFloat(carousel.dataset.autoplay || '0');
      if (seconds > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var paused = false;
        var pause = function () { paused = true; };
        var resume = function () { paused = false; };
        carousel.addEventListener('mouseenter', pause);
        carousel.addEventListener('mouseleave', resume);
        carousel.addEventListener('focusin', pause);
        carousel.addEventListener('focusout', resume);
        track.addEventListener('touchstart', function () { paused = true; setTimeout(resume, seconds * 2000); }, { passive: true });
        setInterval(function () {
          if (paused || document.hidden || carousel.classList.contains('is-static')) return;
          var max = track.scrollWidth - track.clientWidth - 2;
          if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
          else track.scrollBy({ left: step(), behavior: 'smooth' });
        }, seconds * 1000);
      }
    });
  }

  /* ---------- Contatore carrello e avviso ---------- */
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function refreshCartCount() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }
  var toastTimer;
  function showToast(text) {
    var toast = qs('#CartToast');
    if (!toast) return;
    qs('[data-toast-text]', toast).textContent = text;
    toast.removeAttribute('hidden');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.setAttribute('hidden', ''); }, 4500);
  }

  /* ---------- Carrello laterale ---------- */
  function cartDrawerEl() { return qs('[data-cart-drawer]'); }
  function openCartDrawer() {
    var d = cartDrawerEl();
    if (!d) return false;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    var close = qs('[data-cart-drawer-close].header__icon', d);
    if (close) setTimeout(function () { close.focus(); }, 50);
    return true;
  }
  function closeCartDrawer() {
    var d = cartDrawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-locked');
  }
  function renderCartDrawer(html, open) {
    var root = qs('[data-cart-drawer-root]');
    if (!root || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-root]');
    if (!fresh) return;
    var wasOpen = cartDrawerEl() && cartDrawerEl().classList.contains('is-open');
    root.innerHTML = fresh.innerHTML;
    if (open || wasOpen) {
      var d = cartDrawerEl();
      if (d) { d.classList.add('is-open', 'no-anim'); d.setAttribute('aria-hidden', 'false'); requestAnimationFrame(function () { d.classList.remove('no-anim'); }); }
    }
  }
  function refreshCartDrawer(open) {
    return fetch((routes.root || '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderCartDrawer(data['cart-drawer'], false);
        if (open) setTimeout(openCartDrawer, 20);
      })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-drawer-open]');
    if (opener && cartDrawerEl()) { e.preventDefault(); openCartDrawer(); return; }
    if (e.target.closest('[data-cart-drawer-close]')) { closeCartDrawer(); return; }
    var change = e.target.closest('[data-cd-change]');
    if (change) {
      var panel = change.closest('.cart-drawer__panel');
      if (panel) panel.classList.add('is-loading');
      fetch((routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(change.dataset.cdChange, 10), quantity: parseInt(change.dataset.qty, 10), sections: ['cart-drawer'] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          updateCartCount(res.item_count);
          if (res.sections) renderCartDrawer(res.sections['cart-drawer'], true);
        })
        .catch(function () { if (panel) panel.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawerEl() && cartDrawerEl().classList.contains('is-open')) closeCartDrawer();
  });

  /* ---------- Quantità +/- ---------- */
  function initQty(root) {
    qsa('[data-qty]', root).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = qs('input', wrap);
      qsa('[data-qty-btn]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var val = parseInt(input.value || '0', 10) + parseInt(btn.dataset.qtyBtn, 10);
          input.value = Math.max(min, val);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Scheda prodotto ---------- */
  function initGallery(section) {
    var gallery = qs('[data-gallery]', section);
    var track = gallery && qs('[data-slides]', gallery);
    if (!track) return { goTo: function () {} };
    var slides = qsa('[data-slide]', track);
    var thumbs = qsa('[data-thumb]', gallery);
    var counter = qs('[data-gallery-current]', gallery);
    var current = 0;

    function goTo(index, smooth) {
      if (!slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(index) {
      current = index;
      if (counter) counter.textContent = index + 1;
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      var active = thumbs[index];
      if (active && active.parentNode && active.parentNode.parentNode.scrollWidth > active.parentNode.parentNode.clientWidth) {
        active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (index !== current) setActive(index);
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); setActive(i); }); });
    var prev = qs('[data-gallery-prev]', gallery);
    var next = qs('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(current > 0 ? current - 1 : slides.length - 1); });
    if (next) next.addEventListener('click', function () { goTo(current < slides.length - 1 ? current + 1 : 0); });

    /* Zoom al passaggio del mouse (solo dispositivi con mouse) */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      qsa('.product__slide--zoom', track).forEach(function (slide) {
        var img = qs('img', slide);
        if (!img) return;
        slide.addEventListener('mousemove', function (e) {
          var r = slide.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
      });
    }

    /* Clic sulla foto: apre la galleria a schermo intero */
    var lightbox = initLightbox(section);
    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function () { lightbox.open(i); });
    });
    var expand = qs('[data-lightbox-open]', gallery);
    if (expand) expand.addEventListener('click', function () { lightbox.open(current); });

    return {
      goToMedia: function (mediaId) {
        var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
        if (i > -1) { goTo(i); setActive(i); }
      }
    };
  }

  /* Galleria a schermo intero: scorrimento col dito, zoom a due dita, doppio tocco, rotellina, trascinamento */
  function initLightbox(section) {
    var dialog = qs('[data-lightbox]', section);
    if (!dialog || typeof dialog.showModal !== 'function') return { open: function () {} };
    var track = qs('[data-lightbox-track]', dialog);
    var slides = qsa('[data-lightbox-slide]', dialog);
    var thumbs = qsa('[data-lightbox-thumb]', dialog);
    var counter = qs('[data-lightbox-current]', dialog);
    var level = qs('[data-lightbox-level]', dialog);
    var MAX = 4;
    var current = 0, scale = 1, tx = 0, ty = 0;
    var pointers = {}, gesture = null, lastTap = 0, swipeX = 0;

    function img() { return qs('img', slides[current]); }
    function clamp() {
      var el = img(), slide = slides[current];
      if (!el) return;
      var maxX = Math.max(0, (el.offsetWidth * scale - slide.clientWidth) / 2);
      var maxY = Math.max(0, (el.offsetHeight * scale - slide.clientHeight) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    }
    function apply(animate) {
      var el = img();
      if (!el) return;
      clamp();
      el.style.transition = animate ? 'transform .3s ease' : 'none';
      el.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
      dialog.classList.toggle('is-zoomed', scale > 1.01);
      if (level) level.textContent = Math.round(scale * 100) + '%';
    }
    function zoomAt(newScale, cx, cy, animate) {
      var slide = slides[current], r = slide.getBoundingClientRect();
      var px = (cx === undefined ? r.left + r.width / 2 : cx) - (r.left + r.width / 2);
      var py = (cy === undefined ? r.top + r.height / 2 : cy) - (r.top + r.height / 2);
      newScale = Math.min(MAX, Math.max(1, newScale));
      tx = px - (px - tx) * (newScale / scale);
      ty = py - (py - ty) * (newScale / scale);
      scale = newScale;
      if (scale === 1) { tx = 0; ty = 0; }
      apply(animate);
    }
    function reset() { scale = 1; tx = 0; ty = 0; slides.forEach(function (sl) { var i = qs('img', sl); if (i) i.style.transform = ''; }); dialog.classList.remove('is-zoomed'); if (level) level.textContent = '100%'; }
    function moveTrack(offset, animate) {
      track.style.transition = animate ? 'transform .45s cubic-bezier(.2,.7,.2,1)' : 'none';
      track.style.transform = 'translate3d(calc(' + (-current * 100) + '% + ' + offset + 'px),0,0)';
    }
    function goTo(i, animate) {
      reset();
      current = (i + slides.length) % slides.length;
      moveTrack(0, animate);
      if (counter) counter.textContent = current + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
    }

    var stage = track.parentNode;
    track.addEventListener('pointerdown', function (e) {
      track.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        gesture = { type: 'pinch', dist: Math.hypot(a.x - b.x, a.y - b.y), scale: scale, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 };
        moveTrack(0, true);
      } else if (ids.length === 1) {
        gesture = { type: scale > 1.01 ? 'pan' : 'swipe', x: e.clientX, y: e.clientY, tx: tx, ty: ty, moved: false };
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId] || !gesture) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (gesture.type === 'pinch' && ids.length >= 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt(gesture.scale * d / gesture.dist, (a.x + b.x) / 2, (a.y + b.y) / 2, false);
      } else if (gesture.type === 'pan') {
        tx = gesture.tx + (e.clientX - gesture.x);
        ty = gesture.ty + (e.clientY - gesture.y);
        gesture.moved = gesture.moved || Math.abs(e.clientX - gesture.x) + Math.abs(e.clientY - gesture.y) > 6;
        apply(false);
      } else if (gesture.type === 'swipe') {
        swipeX = e.clientX - gesture.x;
        gesture.moved = gesture.moved || Math.abs(swipeX) > 6;
        if (slides.length > 1) moveTrack(swipeX, false);
      }
    });
    function end(e) {
      if (!pointers[e.pointerId]) return;
      delete pointers[e.pointerId];
      if (!gesture) return;
      if (gesture.type === 'pinch') {
        if (Object.keys(pointers).length === 0) { gesture = null; if (scale < 1.05) zoomAt(1, undefined, undefined, true); }
        return;
      }
      if (gesture.type === 'swipe') {
        if (Math.abs(swipeX) > 60 && slides.length > 1) goTo(current + (swipeX < 0 ? 1 : -1), true);
        else moveTrack(0, true);
      }
      if (!gesture.moved) {
        var now = Date.now();
        if (now - lastTap < 300) { zoomAt(scale > 1.01 ? 1 : 2.5, e.clientX, e.clientY, true); lastTap = 0; }
        else lastTap = now;
      }
      swipeX = 0;
      gesture = null;
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomAt(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY, false);
    }, { passive: false });
    track.addEventListener('dblclick', function (e) { e.preventDefault(); });

    qsa('[data-lightbox-zoom]', dialog).forEach(function (b) {
      b.addEventListener('click', function () { zoomAt(scale + parseInt(b.dataset.lightboxZoom, 10) * 0.75, undefined, undefined, true); });
    });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k, true); }); });
    var prev = qs('[data-lightbox-prev]', dialog);
    var next = qs('[data-lightbox-next]', dialog);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
    if (next) next.addEventListener('click', function () { goTo(current + 1, true); });
    qs('[data-lightbox-close]', dialog).addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') goTo(current + 1, true);
      if (e.key === 'ArrowLeft') goTo(current - 1, true);
      if (e.key === '+' || e.key === '=') zoomAt(scale + 0.75, undefined, undefined, true);
      if (e.key === '-') zoomAt(scale - 0.75, undefined, undefined, true);
    });
    dialog.addEventListener('close', function () { reset(); pointers = {}; gesture = null; document.documentElement.classList.remove('is-locked'); });
    window.addEventListener('resize', function () { if (dialog.open) apply(false); });

    return {
      open: function (i) {
        qsa('img', dialog).forEach(function (el) { el.loading = 'eager'; });
        dialog.showModal();
        document.documentElement.classList.add('is-locked');
        goTo(i || 0, false);
      }
    };
  }

  function initStickyBuy(section) {
    var bar = qs('[data-sticky-buy]', section);
    var area = qs('[data-buy-area]', section);
    if (!bar || !area || !('IntersectionObserver' in window)) return;
    var footer = qs('.site-footer');
    var areaVisible = true, footerVisible = false, pastArea = false;
    function update() {
      var show = !areaVisible && pastArea && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = qs('[data-sticky-add]', bar);
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      areaVisible = entries[0].isIntersecting;
      pastArea = entries[0].boundingClientRect.top < 0;
      update();
    }).observe(area);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
  }

  function initProduct(section) {
    var dataEl = qs('[data-product-json]', section);
    var form = qs('[data-product-form]', section);
    if (!dataEl || !form || section.dataset.productBound) return;
    section.dataset.productBound = '1';
    var data = JSON.parse(dataEl.textContent);
    var idInput = qs('input[name="id"]', form);
    var addBtn = qs('[data-add-button]', form);
    var addLabel = qs('[data-add-label]', form);
    var priceEl = qs('[data-price]', section);
    var invEl = qs('[data-inventory]', section);
    var errorEl = qs('[data-error]', section);
    var saleBadge = qs('[data-sale-badge]', section);
    var uniquePill = qs('[data-unique-pill]', section);
    var stickyPrice = qs('[data-sticky-price]', section);
    var stickyBtn = qs('[data-sticky-add]', section);
    var stickyLabel = qs('[data-sticky-label]', section);
    var gallery = initGallery(section);
    initStickyBuy(section);

    function selectedOptions() {
      return qsa('[data-option]', section).map(function (fs) {
        var checked = qs('input:checked', fs);
        var current = qs('[data-option-current]', fs);
        if (checked && current) current.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function setButtons(disabled, label) {
      addBtn.disabled = disabled;
      addLabel.textContent = label;
      if (stickyBtn) stickyBtn.disabled = disabled;
      if (stickyLabel) stickyLabel.textContent = label;
    }
    function render(variant) {
      if (!variant) {
        setButtons(true, strings.unavailable);
        if (invEl) invEl.textContent = '';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (stickyPrice) stickyPrice.innerHTML = variant.price_html;
      setButtons(!variant.available, variant.available ? strings.addToCart : strings.soldOut);
      if (invEl) invEl.textContent = variant.inventory_text || '';
      if (saleBadge) {
        saleBadge.hidden = !variant.saving;
        saleBadge.textContent = variant.saving ? '-' + variant.saving + '%' : '';
      }
      if (uniquePill) uniquePill.hidden = !variant.unique;
      if (variant.media_id) gallery.goToMedia(variant.media_id);
      if (data.updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    qsa('[data-option]', section).forEach(function (fs) {
      fs.addEventListener('change', function () { render(findVariant(selectedOptions())); });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (errorEl) errorEl.textContent = '';
      setButtons(true, addLabel.textContent);
      addBtn.classList.add('is-loading');
      fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(idInput.value, 10), quantity: parseInt((qs('input[name="quantity"]', form) || { value: 1 }).value, 10) || 1 }]
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || strings.error);
          bumpCart();
          if (theme.cartType === 'drawer' && cartDrawerEl() !== null) {
            var sticky = qs('[data-sticky-buy]', section);
            if (sticky) sticky.classList.remove('is-visible');
            refreshCartDrawer(true);
          } else {
            showToast(strings.added);
          }
          return refreshCartCount();
        })
        .catch(function (err) { if (errorEl) errorEl.textContent = err.message || strings.error; })
        .then(function () {
          addBtn.classList.remove('is-loading');
          render(findVariant(selectedOptions()) || data.variants[0]);
        });
    });
  }

  function bumpCart() {
    var icon = qs('#HeaderCart');
    if (!icon) return;
    icon.classList.remove('is-bumped');
    void icon.offsetWidth;
    icon.classList.add('is-bumped');
  }

  /* ---------- Header trasparente sopra l'hero (home) ---------- */
  function initHeaderOverlay() {
    var header = qs('[data-header-overlay]');
    if (!header) return;
    var first = qs('#MainContent > .shopify-section');
    if (!first || !qs('.hero', first)) {
      /* Prima sezione senza foto: l'header diventa normale e fisso */
      header.classList.remove('site-header--overlay');
      header.removeAttribute('data-header-overlay');
      header.classList.add('site-header--fixed');
      header.setAttribute('data-header-fixed', '');
      var spacer = document.createElement('div');
      spacer.className = 'header-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      header.parentNode.insertBefore(spacer, header.nextSibling);
      initHeaderFixed();
      return;
    }
    document.body.classList.add('has-overlay-header');
    var bar = qs('.announcement');
    function update() {
      var offset = bar ? Math.max(bar.offsetHeight - window.scrollY, 0) : 0;
      header.style.top = offset + 'px';
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Zoom con due dita: ferma le animazioni pesanti finché la pagina è ingrandita ---------- */
  function initZoomGuard() {
    var vv = window.visualViewport;
    if (!vv) return;
    var root = document.documentElement, zoomed = false, pinching = false, timer;
    function set(now) { if (now !== zoomed) { zoomed = now; root.classList.toggle('is-zoomed', now); } }
    function check() {
      clearTimeout(timer);
      if (vv.scale > 1.05 || pinching) return set(true);
      /* Si riaccende solo quando la pagina è tornata davvero normale */
      timer = setTimeout(function () { if (vv.scale <= 1.05 && !pinching) set(false); }, 250);
    }
    /* Ferma tutto appena si appoggiano due dita, prima che la pagina inizi a ingrandirsi */
    document.addEventListener('touchstart', function (e) { if (e.touches.length > 1) { pinching = true; set(true); } }, { passive: true });
    document.addEventListener('touchend', function (e) { if (e.touches.length < 2 && pinching) { pinching = false; check(); } }, { passive: true });
    document.addEventListener('touchcancel', function () { pinching = false; check(); }, { passive: true });
    document.addEventListener('gesturestart', function () { pinching = true; set(true); }, { passive: true });
    document.addEventListener('gestureend', function () { pinching = false; check(); }, { passive: true });
    vv.addEventListener('resize', check, { passive: true });
    check();
  }

  /* ---------- Header fisso: misura l'altezza e segue la barra annunci ---------- */
  function initHeaderFixed() {
    var header = qs('[data-header-fixed]');
    if (!header || header.dataset.fixedBound) return;
    header.dataset.fixedBound = '1';
    var bar = qs('.announcement');
    function measure() { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); }
    function update() {
      var offset = bar ? Math.max(bar.offsetHeight - window.scrollY, 0) : 0;
      header.style.top = offset + 'px';
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }
    measure();
    update();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
    window.addEventListener('resize', function () { measure(); update(); });
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Effetto profondità (parallasse) ---------- */
  function initParallax() {
    var items = qsa('[data-parallax]');
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (document.documentElement.classList.contains('is-zoomed')) return;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.dataset.parallax) || 0.2;
        var shift = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Numeri che salgono (fasce di prezzo) ---------- */
  function countUp(el) {
    if (el.dataset.counted) return;
    var m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    el.dataset.counted = '1';
    var target = parseInt(m[1], 10), rest = m[2], start = null, duration = 1200;
    function frame(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + rest;
      if (p < 1) requestAnimationFrame(frame);
    }
    el.textContent = '0' + rest;
    requestAnimationFrame(frame);
  }
  function initCountUp(root) {
    if (!document.body.classList.contains('count-up') || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    qsa('.tier__amount, [data-count-up]', root).forEach(function (el) { io.observe(el); });
  }

  /* ---------- Consigli di Shopify ("Potrebbe interessarti anche") ---------- */
  function initRecommendations(root) {
    qsa('[data-recommendations]', root).forEach(function (el) {
      if (el.dataset.loaded || !el.dataset.url) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = qs('[data-recommendations]', doc);
          if (fresh && qs('.card', fresh)) {
            el.innerHTML = fresh.innerHTML;
            initCarousels();
            initCardSliders(el);
            initReveal(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Condividi ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.dataset.url, msg = btn.parentNode.querySelector('[data-share-msg]');
    if (navigator.share) { navigator.share({ title: btn.dataset.title, url: url }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () {
      if (msg) { msg.textContent = strings.linkCopied; setTimeout(function () { msg.textContent = ''; }, 2500); }
    });
  });

  /* ---------- Linea dei passi che si disegna ---------- */
  function initStepsLine(root) {
    if (!('IntersectionObserver' in window)) return;
    qsa('.steps__list', root).forEach(function (list) {
      new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { list.classList.add('is-drawn'); o.disconnect(); } }, { threshold: 0.4 }).observe(list);
    });
  }

  /* ---------- Animazioni di comparsa ---------- */
  var REVEAL_SELECTOR = [
    '.section-title', '.section-head', '.carousel__track > li', '.product-grid > li', '.collection-grid > li', '.services > li', '.split-banner__content > *',
    '.story__media', '.story__content > *', '.step', '.stat', '.faq__intro > *', '.faq__item', '.collection-cards > li', '.newsletter--card > *', '.footer__grid > *', '.search-hero__inner > *', '.split-banner__media', '.newsletter > *', '.rich-text > *', '.page-header',
    '.collection-hero', '.product__head', '.trust', '.tab', '.footer__top > *', '.marquee'
  ].join(',');
  var SPLIT_SELECTOR = '.section-title, .split-banner__title, .newsletter__title, .story__content h2, .search-hero__title, .steps__title, .collection-card__title';
  /* Divide un titolo in parole che salgono una alla volta */
  function splitWords(el) {
    if (el.classList.contains('is-split')) return;
    var index = 0;
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeType !== 3) return;
      var parts = node.textContent.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
        var outer = document.createElement('span');
        outer.className = 'word';
        var inner = document.createElement('span');
        inner.className = 'word__in';
        inner.style.setProperty('--w', index++);
        inner.textContent = part;
        outer.appendChild(inner);
        frag.appendChild(outer);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.classList.add('is-split');
  }
  var revealObserver = null;
  function initReveal(root) {
    if (!document.body.classList.contains('anim') || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Nell'editor di Shopify tutto resta sempre visibile, per lavorare comodi */
    if (window.Shopify && window.Shopify.designMode) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    qsa(REVEAL_SELECTOR, root).forEach(function (el) {
      if (el.classList.contains('reveal')) return;
      var index = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      el.style.setProperty('--reveal-delay', (Math.min(index % 6, 5) * 0.08) + 's');
      if (el.matches(SPLIT_SELECTOR)) splitWords(el);
      qsa(SPLIT_SELECTOR, el).forEach(splitWords);
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
    setTimeout(function () {
      qsa('.reveal:not(.is-visible)', root).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 1800);
  }

  /* ---------- Carrello ---------- */
  function initCart(root) {
    var cart = qs('[data-cart]', root);
    if (!cart) return;
    var sectionId = cart.dataset.sectionId;
    initQty(cart);

    function change(line, quantity) {
      cart.classList.add('is-loading');
      return fetch((routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || strings.error);
          updateCartCount(res.body.item_count);
          var html = res.body.sections && res.body.sections[sectionId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = qs('[data-cart]', doc);
            if (fresh) {
              cart.replaceWith(fresh);
              initCart(fresh.parentNode);
              return;
            }
          }
          window.location.reload();
        })
        .catch(function (err) {
          cart.classList.remove('is-loading');
          var msg = qs('[data-cart-error]', cart);
          if (msg) msg.textContent = err.message || strings.error;
        });
    }

    qsa('[data-line-qty]', cart).forEach(function (input) {
      input.addEventListener('change', function () {
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        change(parseInt(input.dataset.lineQty, 10), q);
      });
    });
    qsa('[data-line-remove]', cart).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        change(parseInt(btn.dataset.lineRemove, 10), 0);
      });
    });
  }

  /* ---------- Foto sfogliabili nelle card ---------- */
  function initCardSliders(root) {
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    qsa('[data-card]', root).forEach(function (card) {
      var track = qs('[data-card-slides]', card);
      if (!track || card.dataset.bound) return;
      card.dataset.bound = '1';
      var dots = qsa('.card__dot', card);
      var count = track.children.length;
      function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
      function goTo(i) {
        i = (i + count) % count;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      track.addEventListener('scroll', function () {
        var i = index();
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      var prev = qs('[data-card-prev]', card), next = qs('[data-card-next]', card);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); goTo(index() - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); goTo(index() + 1); });
      if (fine) {
        card.addEventListener('mouseenter', function () { if (index() === 0) goTo(1); });
        card.addEventListener('mouseleave', function () { goTo(0); });
      }
    });
  }

  /* ---------- Pagina collezione ---------- */
  function initCollection(root) {
    var section = qs('[data-collection]', root);
    if (!section || section.dataset.bound) return;
    section.dataset.bound = '1';

    /* Barra fissa sotto l'header */
    var toolbar = qs('.collection-toolbar', section);
    var header = qs('.site-header');
    function setTop() {
      if (!toolbar) return;
      var wrap = header ? (header.closest('.shopify-section') || header) : null;
      var sticky = wrap && (getComputedStyle(wrap).position === 'sticky' || getComputedStyle(header).position === 'fixed');
      toolbar.style.setProperty('--sticky-top', (sticky ? header.offsetHeight : 0) + 'px');
    }
    setTop();
    window.addEventListener('resize', setTop);
    if (toolbar && 'IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      toolbar.parentNode.insertBefore(sentinel, toolbar);
      new IntersectionObserver(function (e) { toolbar.classList.toggle('is-stuck', !e[0].isIntersecting && e[0].boundingClientRect.top < 0 + ((header && header.offsetHeight) || 0)); }, { rootMargin: '-' + ((header && header.offsetHeight) || 0) + 'px 0px 0px 0px' }).observe(sentinel);
    }

    /* Pannello filtri */
    var drawer = qs('[data-filter-drawer]', section);
    var opener = qs('[data-filter-open]', section);
    if (drawer && opener) {
      var open = function () { if (toolbar) toolbar.classList.add('has-drawer'); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); opener.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('is-locked'); var f = qs('summary, input', drawer); if (f) f.focus(); };
      var close = function () { if (toolbar) toolbar.classList.remove('has-drawer'); drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); opener.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('is-locked'); opener.focus(); };
      opener.addEventListener('click', open);
      qsa('[data-filter-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    /* Scelta della griglia (ricordata nel browser) */
    var grid = qs('[data-product-grid]', section);
    var toggles = qsa('[data-grid-cols]', section);
    function applyCols(cols, animate) {
      if (!grid) return;
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      if (animate) { grid.classList.add('is-switching'); }
      setTimeout(function () {
        if (desktop) { grid.style.setProperty('--cols-d', cols); grid.style.setProperty('--cols-t', Math.min(cols, 3)); }
        else grid.style.setProperty('--cols-m', cols);
        grid.classList.remove('is-switching');
      }, animate ? 220 : 0);
      toggles.forEach(function (t) { t.classList.toggle('is-active', t.dataset.gridCols === String(cols)); });
    }
    if (grid && toggles.length) {
      var key = window.matchMedia('(min-width: 990px)').matches ? 'rv-cols-d' : 'rv-cols-m';
      var saved = null;
      try { saved = localStorage.getItem(key); } catch (e) {}
      applyCols(saved || (key === 'rv-cols-d' ? grid.dataset.colsD : grid.dataset.colsM), false);
      toggles.forEach(function (t) {
        t.addEventListener('click', function () {
          applyCols(t.dataset.gridCols, true);
          try { localStorage.setItem(key, t.dataset.gridCols); } catch (e) {}
        });
      });
    }

    /* Pulsante "Carica altri" */
    var more = qs('[data-load-more]', section);
    function loadNext() {
      if (!more || !more.isConnected || !grid) return Promise.resolve(false);
      more.classList.add('is-loading');
      return fetch(more.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          qsa('[data-product-grid] > li', doc).forEach(function (li) { grid.appendChild(document.adoptNode(li)); });
          initCardSliders(grid);
          initReveal(grid);
          var wrap = qs('[data-load-more-wrap]', section);
          var shown = grid.children.length;
          var total = wrap ? parseInt(wrap.dataset.total, 10) : shown;
          var shownEl = qs('[data-load-more-shown]', section);
          if (shownEl) shownEl.textContent = shown;
          var bar = qs('[data-load-more-bar]', section);
          if (bar) bar.style.width = Math.min(100, shown / total * 100) + '%';
          var nextBtn = qs('[data-load-more]', doc);
          if (nextBtn) { more.href = nextBtn.href; more.classList.remove('is-loading'); return true; }
          more.remove();
          return false;
        });
    }
    function loadAll(guard) { guard = guard || 0; return loadNext().then(function (again) { return again && guard < 25 ? loadAll(guard + 1) : true; }); }
    var moreWrap = qs('[data-load-more-wrap]', section);
    var gridEnd = qs('[data-grid-end]', section);
    var busy = false;
    function showEnd() {
      if (!gridEnd) return;
      gridEnd.hidden = false;
      requestAnimationFrame(function () { gridEnd.classList.add('is-in'); });
    }
    function loadMoreAnimated() {
      if (busy || !more || !more.isConnected) return Promise.resolve(false);
      busy = true;
      if (moreWrap) moreWrap.classList.add('is-loading');
      return loadNext().then(function (again) {
        busy = false;
        if (moreWrap) moreWrap.classList.remove('is-loading');
        applyTierFilter();
        if (!again) showEnd();
        return again;
      });
    }
    if (more && grid) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        loadMoreAnimated().catch(function () { window.location.href = more.href; });
      });
      /* Caricamento automatico arrivando in fondo */
      if (moreWrap && moreWrap.hasAttribute('data-infinite') && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && activeMax === null) loadMoreAnimated();
        }, { rootMargin: '0px 0px 300px 0px' }).observe(moreWrap);
      }
    } else if (gridEnd && !gridEnd.hidden && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, o) { if (entries[0].isIntersecting) { gridEnd.classList.add('is-in'); o.disconnect(); } }, { threshold: 0.3 }).observe(gridEnd);
    }

    /* Fasce di prezzo che filtrano subito, anche senza collezione collegata */
    var activeMax = null;
    var countEl = qs('.toolbar__count', section);
    var emptyEl = qs('[data-tier-empty]', section);
    function applyTierFilter() {
      if (!grid) return;
      var visible = 0;
      qsa(':scope > li', grid).forEach(function (li) {
        var card = qs('[data-price]', li);
        var price = card ? parseInt(card.dataset.price, 10) : 0;
        var show = activeMax === null || price <= activeMax * 100;
        li.hidden = !show;
        if (show) { visible++; li.classList.add('is-visible'); }
      });
      if (emptyEl) emptyEl.hidden = visible > 0;
      var wrap = qs('[data-load-more-wrap]', section);
      if (wrap) wrap.hidden = activeMax !== null;
      if (countEl && activeMax !== null) countEl.textContent = (visible === 1 ? strings.productOne : strings.productOther).replace('#', visible);
      if (bannerCount) bannerCount.textContent = activeMax !== null ? (visible === 1 ? strings.productOne : strings.productOther).replace('#', visible) : baseCount;
    }
    var bannerTitle = qs('.collection-banner__title', section);
    var bannerCount = qs('.collection-banner__count', section);
    var baseTitle = bannerTitle ? bannerTitle.innerHTML : '';
    var baseCount = bannerCount ? bannerCount.textContent : '';
    function setActive(link) {
      qsa('[data-tier-max], [data-tier-all], .tier-tab', section).forEach(function (t) {
        var same = t === link || (link && link.dataset.tierMax && t.dataset.tierMax === link.dataset.tierMax);
        t.classList.toggle('is-active', !!same);
      });
      /* Il titolo in alto diventa la fascia scelta, es. "Fino a 20 €" */
      if (bannerTitle) {
        var title = link && link.dataset.tierTitle;
        if (title) { bannerTitle.innerHTML = ''; var outer = document.createElement('span'); outer.className = 'hero__line'; var inner = document.createElement('span'); inner.textContent = title; outer.appendChild(inner); bannerTitle.appendChild(outer); }
        else bannerTitle.innerHTML = baseTitle;
      }
    }
    function filterBy(max, link) {
      activeMax = max;
      setActive(link);
      grid && grid.classList.add('is-switching');
      var ready = max !== null && more && more.isConnected ? loadAll() : Promise.resolve();
      ready.then(function () {
        applyTierFilter();
        if (max !== null && gridEnd) gridEnd.hidden = true;
        if (max === null && gridEnd && !(more && more.isConnected)) showEnd();
        setTimeout(function () { grid && grid.classList.remove('is-switching'); }, 30);
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          if (max === null) url.searchParams.delete('filter.v.price.lte'); else url.searchParams.set('filter.v.price.lte', max);
          window.history.replaceState({}, '', url.toString());
        }
      });
    }
    if (grid) {
      /* Ogni clic su una fascia ricarica la pagina con il filtro prezzo del negozio:
         così compaiono sempre TUTTE le cravatte fino a quel prezzo, non solo quelle già caricate */
      var fromUrl = new URL(window.location.href).searchParams.get('filter.v.price.lte');
      if (fromUrl) {
        var match = qsa('[data-tier-max]', section).filter(function (l) { return parseFloat(l.dataset.tierMax) === parseFloat(fromUrl); })[0];
        filterBy(parseFloat(fromUrl), match || null);
      }
    }
  }

  /* ---------- Filtri e ordinamento collezione ---------- */
  function initFilters() {
    qsa('[data-filter-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.hasAttribute('data-autosubmit')) form.submit();
      });
    });
  }

  document.addEventListener('click', function (e) {
    var top = e.target.closest('[data-back-to-top]');
    if (!top) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initSearchToggle();
    initCarousels();
    initQty(document);
    qsa('[data-product-section]').forEach(initProduct);
    initCart(document);
    initFilters();
    initPredictive(document);
    initCardSliders(document);
    initCollection(document);
    initHeaderFixed();
    initHeaderOverlay();
    initZoomGuard();
    initParallax();
    initCountUp(document);
    initStepsLine(document);
    initRecommendations(document);
    initReveal(document);
  });

  /* Editor del tema: reinizializza le sezioni ricaricate */
  document.addEventListener('shopify:section:load', function (e) {
    initCarousels();
    initQty(e.target);
    qsa('[data-product-section]', e.target).forEach(initProduct);
    initCart(e.target);
    if (qs('[data-drawer]', e.target)) initDrawer();
    if (qs('[data-search-modal]', e.target)) initSearchToggle();
    initPredictive(e.target);
    initCardSliders(e.target);
    initCollection(e.target);
    initCountUp(e.target);
    initReveal(e.target);
  });
})();
